/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_SubtitleInputs */

const cs_settings_teams_subtitle = /** @type {(inputs: Settings_Teams_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seskupte makléře, aby kalendář, úkoly a pipeline zůstaly na týmu.`)
};

const en_settings_teams_subtitle = /** @type {(inputs: Settings_Teams_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group brokers so calendars, tasks, and pipelines stay on the team.`)
};

/**
* | output |
* | --- |
* | "Group brokers so calendars, tasks, and pipelines stay on the team." |
*
* @param {Settings_Teams_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_subtitle = /** @type {((inputs?: Settings_Teams_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_subtitle(inputs)
	return cs_settings_teams_subtitle(inputs)
});